angular.module('natgeo').factory('DropShadow', 
function DropShadow()
{
  var NAMESPACE = "http://www.w3.org/2000/svg";

  return function(e)
  {
    if (typeof e.style.webkitSvgShadow !== 'undefined')
    {
      e.style.webkitSvgShadow = '5px 5px 10px rgba(0,0,0,0.5)';
    }
    else if (typeof e.filter !== 'undefined' || e.namespaceURI === NAMESPACE)
    {
      e.setAttribute('filter', 'url(#dropshadow)');
    }
    else if (typeof e.style.filter !== 'undefined')
    {
      e.style.filter = 'url(#dropshadow)';
    }
  };
});